import { render, staticRenderFns } from "./phoneHome.vue?vue&type=template&id=0f063d08&scoped=true&"
import script from "./phoneHome.vue?vue&type=script&lang=js&"
export * from "./phoneHome.vue?vue&type=script&lang=js&"
import style0 from "./phoneHome.vue?vue&type=style&index=0&id=0f063d08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f063d08",
  null
  
)

export default component.exports